import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface ManagementCompanyObject {
  companyName: string;
  companyId: number;
}

export type ManagementCompanyResponse = ManagementCompanyObject[]  


const useGetManagementCompanyApi = () => {
  const call = useCallback(async () => {
    const response = await axiosInstance.get<ManagementCompanyResponse>(api.getManagementCompanies);
    return response.data;
  }, []);

  const { execute, value, isLoading } = useAsync(call, false,undefined, []);

  return {
    getManagementCompany: execute,
    managementCompanies: value,
    isManagementCompanyLoading: isLoading,
  };
};

export default useGetManagementCompanyApi;
